import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notesService } from '../api/notes.service';
import { NOTE_KEYS } from './queryKeys';

/** Restores an old version as the note's current content — adds a new history entry, nothing is deleted. */
export function useRestoreNoteVersion(noteId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (versionId: string) => notesService.restoreVersion(noteId, versionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: NOTE_KEYS.all });
    },
  });
}
